



































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { getPrizeCurrency, getPrizeValue } from '@/utils/prize'
import tournamentStore from '@/modules/tournament/tournament.store'
import { TournamentEntity } from '@/api/tournament'
import TournamentDetailsHeader from '@/modules/tournament/components/TournamentDetailsHeader'
import TournamentBasicInformationMobile from '@/modules/tournament/components/TournamentBasicInformationMobile'
import { TranslateResult } from 'vue-i18n'

interface Prize {
  title: string | TranslateResult
  prize: string
}

@Component({
  components: {
    TournamentDetailsHeader,
    TournamentBasicInformationMobile
  }
})
export default class TournamentDetailsOverview extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)

  /* Vuex State */
  get tournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get tournamentPrizes(): Prize[] {
    if (!this.tournament) return []
    return [
      {
        title: this.$t('TournamentDetailsOverview.Champion'),
        prize: this.tournament.prizeChampionPrize
      },
      {
        title: this.$t('TournamentDetailsOverview.1stRunnerUp'),
        prize: this.tournament.prizeFirstRunnerUpPrize
      },
      {
        title: this.$t('TournamentDetailsOverview.2ndRunnerUp'),
        prize: this.tournament.prizeSecondRunnerUpPrize
      }
    ]
  }

  /* Methods */
  getPrizeCurrency(prize: string) {
    if (!prize) return ''
    return getPrizeCurrency(prize)
  }

  getPrizeValue(prize: string) {
    if (!prize) return ''
    return getPrizeValue(prize)
  }

  @Watch('$vuetify.breakpoint.mobile')
  onViewpointMobile(isMobile: boolean) {
    if (isMobile) {
      this.$router.push({ name: 'InstantMatchDetails' })
    }
  }

  mounted() {
    if (this.$vuetify.breakpoint.mobile) {
      this.$router.push({ name: 'InstantMatchDetails' })
    }
  }
}
